import { useTranslation } from "react-i18next";
import { CONFIGURATION_ERROR, CONSENT_ERROR, EMAIL_NOT_SHARED, EMAIL_UNAVAILABLE, GENERIC_ERROR } from "../../constants";
import { useSearchParams } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { StatusPage } from "UIPalette/StatusPage/StatusPage";

export const SsoSetupStatus = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "accountSecurity.ssoSettings" });
  const [searchParams] = useSearchParams();
  const provider = searchParams.get("provider");
  const qsError = searchParams.get("error");
  const idp = searchParams.get("idp");
  const ssoStatus = searchParams.get("status");
  const [statusBody, setStatusBody] = useState<{ title: string; body: string }>();

  const errors: Record<string, string> = useMemo(
    () => ({
      [CONFIGURATION_ERROR]: t("error.body.configuration"),
      [GENERIC_ERROR]: t("error.body.generic", { provider: provider ?? idp }),
      [CONSENT_ERROR]: t("error.body.consent", { provider: provider ?? idp }),
      [EMAIL_UNAVAILABLE]: t("error.body.emailUnavailable", { provider: provider ?? idp }),
      [EMAIL_NOT_SHARED]: t("error.body.emailNotShared", { provider: provider ?? idp, interpolation: { escapeValue: false } }),
    }),
    [idp, provider, t]
  );

  const dismissAction = () => {
    window.location.assign("com.healthassured.wisdom://app/single-sign-on");
  };

  useEffect(() => {
    if (qsError !== null) {
      setStatusBody({
        title: t("error.title"),
        body: errors[qsError || GENERIC_ERROR] ?? errors[GENERIC_ERROR],
      });
    } else if (ssoStatus === "success") {
      setStatusBody({
        title: t("success.title"),
        body: t("success.body", { provider: provider ?? idp }),
      });
    }
  }, [errors, idp, provider, qsError, ssoStatus, t]);

  if (!statusBody) {
    return null;
  }

  return (
    <StatusPage
      status={qsError !== null ? "error" : "success"}
      title={statusBody.title}
      body={statusBody.body}
      cta={{
        id: "status-modal-confirm-button",
        text: "I understand",
        onClick: dismissAction,
        variant: qsError !== null ? "secondary" : "default"
      }}
    />
  );
};
